import { showPageNotFound } from "./common.js"
import { clearForSignIn } from "../login/login-display.js"
import type { FormMap } from "../../../types/types.js";
import { getSessionId } from "./auth-storage.js";

const authHeader = (): HeadersInit => {
    const sessionId = getSessionId()
    return sessionId ? { "Authorization": `Token ${sessionId}` } : {}
}
const BASE_API_URL = import.meta.env.VITE_API_BASE ?? "";
const SAME_DOMAIN_API_REQUEST = true; // make it false to make a request to api.soundcorset.com

const fetchApi = (url: string, p: RequestInit): Promise<Response> => {
    const apiUrl = (SAME_DOMAIN_API_REQUEST || !url.startsWith('/') || location.hostname.includes('local')) ? url : BASE_API_URL + url
    return fetch(apiUrl, p)
}

export const fetchPostJsonIfValid = (url: string, parameters?: FormData): Promise<FormMap> =>
    fetchPostValidated(url, parameters).then((r: Response) => r.json())

export const fetchPostValidated = (url: string, parameters?: FormData): Promise<Response> =>
    fetchPost(url, parameters).then((r: Response) => {
        return r.ok ? r : Promise.reject(r)
    })

export const fetchPost = (url: string, parameters?: FormData): Promise<Response> => fetchApi(url, { method: "POST", body: parameters, credentials: "include", headers: authHeader() })


const convertResponseToJson = (res: Response): Promise<FormMap> => {
    const contentType = res.headers.get("content-type") || "";
    if (res.ok && contentType.includes("application/json")) {
        return res.json();
    }
    return Promise.reject(res);
}

export const fetchGetJsonFromStaticUrl = async (url: string): Promise<FormMap> => {
    const res = await fetch(url, { method: "GET" })
    return convertResponseToJson(res)
}

export const fetchGetJson = async <T extends Record<string, any> = FormMap>(url: string): Promise<T> => {
    const res = await fetchGet(url)
    return convertResponseToJson(res) as Promise<T>
}

export const fetchGet = (url: string): Promise<Response> => fetchApi(url, { method: "GET", credentials: "include", headers: authHeader() })

export const handleError = (r: Response): void => {
    if (!r.ok) {
        if (r.status == 401) clearForSignIn()
        else showPageNotFound()
    }
}

export const showErrorMessage: Function = (message: string): Function => (r: Response): void => alert(message + ": " + r.status + " - " + r.statusText)

export const handleErrorWithAlert = (response: Response): Response => {
    switch (response.status) {
        case 401: // Unauthorized
            clearForSignIn()
            alert("You need to sign in")
            break
        case 403: // Forbidden, e.g.) one of the users has reported the other
            alert("You can't interact with this user.")
            break
        default: // e.g.) 429: TooManyRequests
            alert("Try again later")
    }
    return response
}
